
    if (window.location.href.includes("collections/")) {
		$(".breadcrumbs__list .breadcrumbs__item:last-child").before('<li class="breadcrumbs__item"><a class="breadcrumbs__link" href="/collections">Product Range</a></li>')
    }


jQuery(document).ready(function() {

// BEGIN of script for .slider-testimonials
	$('.slider-testimonials').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		adaptiveHeight: false,
		// autoplay: true,
		autoplaySpeed: 5500,
		fade: false,
		pauseOnHover: false,
		speed: 600,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		]
	});
// END of script for .slider-testimonials

// BEGIN of script for slider-3-per-row
	$('.slider-3-per-row').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		adaptiveHeight: false,
		// autoplay: true,
		autoplaySpeed: 5000,
		fade: false,
		pauseOnHover: false,
		speed: 600,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		]
	});
// END of script for slider-3-per-row

// BEGIN of script for accordion
	$('.accordion-item-nav').click(function(){
		var _accItemParent = $(this).parents('.accordion-item');
		if (_accItemParent.hasClass('active')) {
			$('.accordion-item').removeClass('active');
			$('.accordion-item .accordion-item-content').slideUp(400,function(){
			});
		} else {
			// $('.accordion-item').removeClass('active');
			// $('.accordion-item .accordion-item-content').slideUp(400);
			_accItemParent.addClass('active');
			_accItemParent.find('.accordion-item-content').slideDown(400,function(){
			});
		}
	})
	$('.accordion-item:first .accordion-item-nav').click();
// END of script for accordion

// BEGIN of script for tabs
	$('.tabs-nav-item').click(function() {
		var _id = $(this).attr('href');
		var _targetElement = $(this).parents('.tabs-wr').find(_id);
		$('.tabs-nav-item').removeClass('active');
		$('.tabs-nav-item-wrapper').removeClass('active');
		$(this).addClass('active');
		$(this).parents('.tabs-nav-item-wrapper').addClass('active');
		$('.tabs-item').removeClass('active');
		_targetElement.addClass('active');
		return false;
	});

	$('.btn-close-tab').click(function(){
		$(this).parents('.tabs-item').removeClass('active');
	})
	// $('.tabs-nav-item:last-child').click();
// END of script for tabs

// BEGIN of script to clone element into other position for mobile views
	$('.mobile-move-element').each(function(){
		var _cloneElement = $(this).clone();
		_cloneElement.appendTo($(this).parents('.box-wr').find('.mobile-move-element-position'));
	});
// END of script to clone element into other position for mobile views











































});

// BEGIN of script for page load
	window.onload = function() {

	// BEGIN of script for page preloader
		$('.spinner-wr').fadeOut(900,function(){
			$(this).remove();
		});
		$('body').addClass('loaded');
	// END of script for page preloader

	// BEGIN of script for init wow.js for animate.css
		if(Modernizr.cssanimations) {
			wow = new WOW({
				mobile: false,
			});
			wow.init();
		}
	// END of script for init wow.js for animate.css



async function getCartQuantityForCollection(targetCollectionHandle) {
    try {
        // 1. Fetch products from the target collection using Shopify's URL
        const collectionResponse = await fetch(`/collections/${targetCollectionHandle}/products.json`);
        const collectionData = await collectionResponse.json();
        
        // Extract the IDs of products belonging to this collection
        const collectionProductIds = new Set(collectionData.products.map(product => product.id));

        // 2. Fetch the current cart data
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();

        // 3. Sum the quantities of items in the cart that match the collection
        let totalItems = 0;
        cartData.items.forEach(cartItem => {
            if (collectionProductIds.has(cartItem.product_id)) {
                totalItems += cartItem.quantity;
            }
        });

        console.log(`Total items from ${targetCollectionHandle} in cart:`, totalItems);
        return totalItems;

    } catch (error) {
        console.error('Error calculating items by collection:', error);
        return 0;
    }
}
// Example usage:
// getCartQuantityForCollection('meals');

async function CheckIfMEalsBundle() {
    // The code stops here for a moment, waits for Shopify, and returns a pure integer
    const _numberOfMeals = await getCartQuantityForCollection('meals');

	if (_numberOfMeals < 5) {
      console.log("Soups+Desserts Deal DISABLED [totalCollectionItems < 5]");
	  $('.kaching-bundles__scratch-off').addClass('bundle-disabled');
    //   return false;
    } else {
      console.log("Soups+Desserts Deal ENABLED [totalCollectionItems >= 5]");
	  $('.kaching-bundles__scratch-off').addClass('bundle-enabled');
    //   return true;
    }

}
CheckIfMEalsBundle();




// cart-drawer-component

async function CheckIfMEalsBundleInCart() {
    // The code stops here for a moment, waits for Shopify, and returns a pure integer
	
		const _numberOfMeals = await getCartQuantityForCollection('meals');
		const _numberOfSoups = await getCartQuantityForCollection('soups');
		const _numberOfDesserts = await getCartQuantityForCollection('desserts');
		if (_numberOfSoups >= 4 && _numberOfMeals < 5) {
			console.log("Soups Deal NO!ЙЙЙЙ SOUPS: "+_numberOfSoups+", MEALS: "+_numberOfMeals);
			alert('Super Deal: You can buy 4 Soups for £8 when you buy any 5 Ready Meals (Only after you selected any 5 Ready Meals)');
			$('.cart-drawer__dialog').addClass('nosoups-bundle');
			// return false;
		} else {
			console.log("Soups Deal YES! SOUPS: "+_numberOfSoups+", MEALS: "+_numberOfMeals);
			$('.cart-drawer__dialog').removeClass('nosoups-bundle');
			// return true;
		}
		if (_numberOfDesserts >= 4 && _numberOfMeals < 5) {
			console.log("Dessert Deal NO! Desserts: "+_numberOfDesserts+", MEALS: "+_numberOfMeals);
			alert('Super Deal: You can buy 4 Desserts for £8 when you buy any 5 Ready Meals (Only after you selected any 5 Ready Meals)');
			$('.cart-drawer__dialog').addClass('noDessert-bundle');
			// return false;
		} else {
			console.log("Dessert Deal YES! Desserts: "+_numberOfDesserts+", MEALS: "+_numberOfMeals);
			$('.cart-drawer__dialog').removeClass('noDessert-bundle');
			// return true;
		}

}

$('cart-drawer-component cart-icon').click(function(){
	CheckIfMEalsBundleInCart();
	console.log('QQQ')
})

$('.cart-items__quantity-controls').click(function(){
	// CheckIfMEalsBundleInCart();
	console.log('QQQaa')
})

// 2. Attach the click listener to your specific elements
document.querySelectorAll('.cart-items__quantity-controls').forEach(element => {
    element.addEventListener('click', async (event) => {
        // Optional: prevent default behavior if you need to do math BEFORE a form submission
        // event.preventDefault(); 

        console.log('Target element clicked. Fetching collection item count...');
	setTimeout(() => {
		CheckIfMEalsBundleInCart();
	}, 1300);


        // Optional: If you used event.preventDefault() above, resume the action here:
        // event.target.closest('form').submit();
    });
});





























	};
// END of script for page loader